$(document).ready(function() {
    $('.post__content iframe').each(function() {
        if (!$(this).closest('.ad--leaderboard').length) {
            // If not within 'ad--leaderboard', wrap the iframe in a div with class 'video-container'
            $(this).wrap('<div class="video-container"></div>');
        }
    });
    // ----------------------------
    //  Removal of empty .ai-content divs
    // ----------------------------
    $('.ai-content:empty').remove();
    
    // ----------------------------
    // wrapping the table press tables
    // ----------------------------
    if($('.post__content table').length ) {
        $('.post__content table').wrap('<div class="table-responsive"></div>');
    }
    
    // ----------------------------
    // make apester iframes responsive
    // ----------------------------
    $('iframe[src*="qmerce"]').attr('width', '100%');
    
    // ----------------------------
    // sticky sidebar
    // ----------------------------
    // $('#sticky-sidebar').stick_in_parent({
    //   parent: '.container',
    //   offset_top: 40
    // });
    
    // ----------------------------
    // AD for single posts
    // ----------------------------
    
    $('body.single-post .post__content').each(function(){
        var t_number = $('h2', this).length;
        if (t_number >= 3) {
        $('.post__content > h2:nth-of-type(3)').before('<div id="imoney_res_mid2"></div>')
        }
    });
});

$(window).on('load', function() {
    callGTMEvent('viewProduct');
});

// Added for datalayer for Moengage
const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "Tablet";
    }
    if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua
        )
    ) {
        return "Mobile";
    }
    return "Desktop";
};

function callGTMEvent(eventname, email = '') {
    var userDev = getDeviceType();
    var eventLang = $('html').attr('lang');
    var dataLayerTemp = {
        event: eventname,
        content_type: 'product',
        user_device: userDev,
        event_lang: eventLang,
        product_id: 'LC-' + id,
        product_category: 'Articles',
        product_sub_category : article_sub_category ,
        product_name: title,
    };

    let dataLayerGTM = JSON.parse(JSON.stringify(dataLayerTemp));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerGTM);

    let dataLayerNetCore = JSON.parse(JSON.stringify(dataLayerTemp));
    var eventname = dataLayerNetCore.event;
    delete dataLayerNetCore.event;

    if (typeof Moengage != 'undefined') {
        Moengage.track_event(eventname, dataLayerNetCore);
    }
    if (typeof window.smartech == 'function') {
        smartech('dispatch', eventname, dataLayerNetCore);
    }
}